import EventEmitter from '../classes/EventEmiter'
import type {
  IContainers,
  IProcessedComponent,
  IProcessedComponentProps,
  IProcessedContainer,
  UnresolvedRecord,
} from '../interfaces'
import { RootState } from '../redux/store'
import { processActions } from '../utils/processActions'
import processData from '../utils/processData'

const getCinnamonProps = <T = unknown>(
  props: UnresolvedRecord,
  state: RootState,
  eventEmitter: EventEmitter,
): IProcessedComponentProps<T> => {
  const cinnamonProps = processData(props, { state })
  return processActions(cinnamonProps, eventEmitter)
}

const processDataValidated = (
  data: UnresolvedRecord | undefined = {},
  state: RootState,
) => processData(data, { state })

export const getCinnamonPropsContainer = (
  { header, body, footer, modals, uid }: IContainers,
  state: RootState,
  eventEmitter: EventEmitter,
): IProcessedContainer => {
  return {
    uid,
    modals,
    header: {
      props: processDataValidated(header?.props, state),
      components:
        header?.components.map<IProcessedComponent>(
          ({ props = {}, ...rest }) => ({
            ...rest,
            props: getCinnamonProps(props, state, eventEmitter),
          }),
        ) || [],
    },
    body: {
      props: processDataValidated(body?.props, state),
      components: body?.components.map<IProcessedComponent>(
        ({ props = {}, ...rest }) => ({
          ...rest,
          props: getCinnamonProps(props, state, eventEmitter),
        }),
      ),
    },
    footer: {
      props: processDataValidated(footer?.props, state),
      components:
        footer?.components.map<IProcessedComponent>(
          ({ props = {}, ...rest }) => ({
            ...rest,
            props: getCinnamonProps(props, state, eventEmitter),
          }),
        ) || [],
    },
  }
}

export default getCinnamonProps
